<template>
  <v-container class="py-7">
    <v-row>
      <v-col cols="12">
        <div class="title-container">
          <div class="title-block">
            <span class="page-title">Conversas</span>
            <v-breadcrumbs class="app-breadcrumb" divider="›" :items="breadcrumbs"></v-breadcrumbs>
          </div>
        </div>
      </v-col>
    </v-row>

    <v-row>
      <v-col cols="12">
        <v-card class="filter-card">
          <v-card-title class="filter-card-title">Filtro</v-card-title>
          <v-card-text>
            <v-form @submit.prevent="load">
              <v-row align="center">
                <v-col cols="12" md="4">
                  <v-select dense label="Status" v-model="filter.status" :items="statuses" item-text="label" item-value="value" outlined hide-details clearable></v-select>
                </v-col>
                <v-col cols="12" md="4">
                  <v-text-field dense label="Aluno" v-model="filter.student_id" outlined hide-details></v-text-field>
                </v-col>
                <v-col cols="12" md="2">
                  <v-btn type="submit" color="primary" elevation="0" block :loading="loading">Filtrar</v-btn>
                </v-col>
              </v-row>
            </v-form>
          </v-card-text>
        </v-card>
      </v-col>
    </v-row>

    <v-row>
      <v-col cols="12">
        <v-data-table
          :headers="headers"
          :items="items"
          :loading="loading"
          :server-items-length="total"
          :options.sync="options"
          :footer-props="footerOptions"
          :disable-sort="true"
          class="app-table hover-table"
          no-data-text="Nenhuma conversa foi encontrada"
          loading-text="Carregando conversas..."
          @update:options="load"
        >
          <template v-slot:[`item.student`]="{ item }">
            <div class="stacked-cell">
              <strong>{{ item.student ? item.student.name : "Aluno não identificado" }}</strong>
              <small>{{ item.class ? item.class.name : "Sem turma" }}</small>
            </div>
          </template>

          <template v-slot:[`item.channel`]="{ item }">
            {{ channelLabel(item.channel) }}
          </template>

          <template v-slot:[`item.status`]="{ item }">
            <v-chip small label :color="statusColor(item.status)" text-color="white">
              {{ statusLabel(item.status) }}
            </v-chip>
          </template>

          <template v-slot:[`item.last_message_at`]="{ item }">
            {{ item.last_message_at | defaultDate("DD/MM/YYYY HH:mm") }}
          </template>

          <template v-slot:[`item.actions`]="{ item }">
            <v-icon @click="open(item)" size="large">mdi-eye-outline</v-icon>
          </template>
        </v-data-table>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
import axios from "axios";

export default {
  name: "ChatList",

  data: () => ({
    loading: false,
    total: 0,
    items: [],
    filter: {
      status: null,
      student_id: "",
    },
    options: {
      page: 1,
      itemsPerPage: 10,
    },
    statuses: [
      { label: "Aberta", value: "open" },
      { label: "Aguardando escola", value: "waiting_school" },
      { label: "Aguardando responsável", value: "waiting_answerable" },
      { label: "Encerrada", value: "closed" },
    ],
    headers: [
      { text: "Aluno / turma", value: "student" },
      { text: "Canal", value: "channel" },
      { text: "Status", value: "status" },
      { text: "Última mensagem", value: "last_message_at" },
      { text: "Ações", value: "actions", sortable: false },
    ],
    footerOptions: {
      itemsPerPageText: "Itens por página:",
      itemsPerPageOptions: [10, 20, 30, 40, 50],
      pageText: "{0}-{1} de {2}",
    },
    breadcrumbs: [
      { text: "Homepage", disabled: false, to: "/home", exact: true },
      { text: "Conversas", disabled: true, exact: true },
    ],
  }),

  created() {
    this.load();
  },

  methods: {
    async load() {
      const search = {};
      if (this.filter.status) search.status = this.filter.status;
      if (this.filter.student_id) search.student_id = this.filter.student_id;

      this.loading = true;

      try {
        const result = await axios.get("/api/v1/chat/conversations", {
          params: {
            page: this.options.page,
            limit: this.options.itemsPerPage,
            search: Object.keys(search).length ? JSON.stringify(search) : null,
          },
        });

        this.items = result.data.content.data;
        this.total = result.data.content.paging.total;
      } catch (error) {
        this.$dialog.notify.error(this.$codes(error), { position: "top-right", timeout: 3000 });
      } finally {
        this.loading = false;
      }
    },

    open(item) {
      this.$router.push(`/conversas/${item.id}`);
    },

    channelLabel(channel) {
      const labels = {
        class_team: "Equipe da turma",
        teacher: "Professores",
        assistant: "Auxiliares",
        coordination: "Coordenação",
      };

      return labels[channel] || channel || "Conversa";
    },

    statusLabel(status) {
      const labels = {
        open: "Aberta",
        waiting_school: "Aguardando escola",
        waiting_answerable: "Aguardando responsável",
        closed: "Encerrada",
      };

      return labels[status] || status;
    },

    statusColor(status) {
      if (status === "closed") return "grey";
      if (status === "waiting_school") return "warning";
      if (status === "waiting_answerable") return "primary";
      return "success";
    },
  },
};
</script>

<style scoped lang="scss">
.stacked-cell strong,
.stacked-cell small {
  display: block;
}

.stacked-cell small {
  color: #64748b;
  font-size: 11px;
  margin-top: 2px;
}
</style>
